<template>
  <div class="search">
        <div class="sp-only sp-search-form">
          <form id="search-form" name="searchFormSP" action="/search/" method="GET">
            <div class="search-input-wrapper">
              <input class="search-input" type="search" name="q" v-model="keyword">
              <button class="search-submit" type="submit"><img src="/assets/img/icon-search.png" alt="検索"></button>
              <input type="hidden" name="availability" value="false">
              <input type="hidden" name="sort" value="normal">
              <input type="hidden" name="ec" value="amazon,rakuten,yahoo">
              <input type="hidden" name="minPrice" value="">
              <input type="hidden" name="maxPrice" value="">
            </div>
          </form>
            <ul class="ec-list ec-select">
              <li data-ec="amazon" for="ec-amazon" class="ec-label">
                <img class="sp-only" src="/assets/img/icon-amazon_sp_on.png" alt="Amazon">
                <img class="sp-only" src="/assets/img/icon-amazon_sp_off.png" alt="Amazon">
              </li>
              <li data-ec="rakuten" for="ec-rakuten" class="ec-label">
                <img class="sp-only" src="/assets/img/icon-rakuten_sp_on.png" alt="楽天市場">
                <img class="sp-only" src="/assets/img/icon-rakuten_sp_off.png" alt="楽天市場">
              </li>
              <li data-ec="yahoo" for="ec-yahoo" class="ec-label active">
                <img class="sp-only" src="/assets/img/icon-yahoo_sp_on.png" alt="Yahoo!">
                <img class="sp-only" src="/assets/img/icon-yahoo_sp_off.png" alt="Yahoo!">
              </li>
            </ul>
        </div>
      <div class="search-header">
        <div class="search-header-group">
          <h1 class="search-keyword pc-only">{{ this.keyword }}</h1>

          <div class="search-option-group">
            <b-dropdown class="search-option-select" v-bind:text="sort.label">
              <b-dropdown-item v-for="option in sortOptions" @click="sortBy(option)">{{ option.label }}</b-dropdown-item>
            </b-dropdown>
            <button class="search-option-button" type="button" @click="toggleFilter" v-bind:class="{ active: isFilterShow }"> 絞り込み </button>
          </div>
        </div>

        <h1 class="search-keyword sp-only">{{ this.keyword }}</h1>

        <div class="search-condition" v-if="sort.key !== 'normal' && sort.key !== '' || price.min || price.max || showOnlyAvailable">
          <h3 class="search-condition-title">選択中の条件:</h3>
          <span class="search-condition-label" v-if="sort.key === 'price0'">価格が低い順 <span class="search-condition-reset" @click="resetSort"></span></span>
          <span class="search-condition-label" v-if="sort.key === 'price1'">価格が高い順 <span class="search-condition-reset" @click="resetSort"></span></span>

          <span class="search-condition-label" v-if="price.min || price.max">
            <span v-if="price.min">{{ price.min }}円</span>
            <span v-if="price.min || price.max">〜</span>
            <span v-if="price.max">{{ price.max }}円</span>
            <span v-if="price.min || price.max" class="search-condition-reset" @click="resetPrice"></span>
          </span>

          <span class="search-condition-label" v-if="showOnlyAvailable">在庫ありのみ <span class="search-condition-reset" @click="resetAvailable"></span></span>

        </div>

        <!-- 絞り込みフィルター -->
        <div  class="overlay" v-bind:class="{show : isFilterShow}" @click="closeFilter"></div>
        <div class="search-filter" @keyup.enter="setFilterCondition()">
            <div class="search-filter-option" v-bind:class="{show : isFilterShow}">
              <div class="search-filter-close" @click="closeFilter"></div>
              <div class="search-filter-option-content">
                <div class="filter-block">
                  <h4 class="filter-block-title">在庫</h4>
                  <div class="radio-list">
                    <input id="availability1" type="radio" name="available" v-model="temp.showOnlyAvailable" v-bind:value="true">
                    <label for="availability1">在庫ありのみを表示</label>

                    <input id="availability2" type="radio" name="available" v-model="temp.showOnlyAvailable" v-bind:value="false">
                    <label for="availability2">在庫なしも含み表示</label>
                  </div>
                </div>

                <div class="filter-block">
                  <h4 class="filter-block-title">価格を設定して絞り込む</h4>
                  <input type="text" class="input-price" name="minPrice" pattern="\d*" v-model="temp.price.min">円 〜
                  <input type="text" class="input-price" name="maxPrice" pattern="\d*" v-model="temp.price.max">円
                    <div class="filter-block-error" v-if="error.priceError !== ''">
                      {{ error.priceError }}
                    </div>
                </div>
              </div>

              <div class="brand-form-action">
                <button class="brand-form-reset" type="button" @click="resetFilterCondition()">設定を解除</button>
                <button class="brand-form-submit" type="button" @click="setFilterCondition()">この条件で検索</button>
              </div>
            </div>
          </div>

      </div>
      <div v-show="isLoading" class="loader"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
      <div v-show="!isLoading">
        <div class="search-error" v-if="error.noKeyword !== ''">
          {{ error.noKeyword }}
        </div>
        <div class="search-error" v-if="resultCount === 0">
          <span>「{{ this.keyword }}」に該当する検索結果は見つかりませんでした。</span>
        </div>
      <div v-else>
              <div v-html="ad_html"></div>
          <ul class="search-result">
            <template v-for="(item,index) in displayItems">
            <li v-bind:class="[item.domain]">
              <div class="item-info">
                <a v-bind:href="item.url" target="_blank" class="item-link">
                  <span class="item-info-image"><img v-bind:src="item.itemImage"></span>
                </a>
                <span class="pc-only">
                  <span class="item-info-name">
                    <a v-bind:href="item.url" target="_blank" class="item-link" v-bind:title="item.itemName">
                      {{ item.itemName | truncate(44, '...')}}
                    </a>
                  </span>
                  <a v-bind:href="item.url" target="_blank" class="item-link">
                    <span class="item-info-price" v-if="item.price"><span class="item-info-price-label">税込み</span> {{ item.price | yen}}</span><br>
                  </a>
                  <a v-bind:href="item.url" target="_blank" class="item-link">
                    <span v-bind:class="'domain-'+item.domain" v-if="item.domain === 'yahoo'">YAHOO!</span>
                    <span v-bind:class="'domain-'+item.domain" v-if="item.domain === 'amazon'">amazon</span>
                    <span v-bind:class="'domain-'+item.domain" v-if="item.domain === 'rakuten'">楽天</span>
                  </a>
                </span>
                <span class="sp-only">
                  <span class="item-info-name">{{ item.itemName | truncate(44, '...')}}</span>
                  <a v-bind:href="item.url" target="_blank" class="item-link">
                    <span class="item-info-price" v-if="item.price"><span class="item-info-price-label">税込み</span> {{ item.price | yen}}</span><br>
                  </a>
                  <a v-bind:href="item.url" target="_blank" class="item-link">
                    <span v-bind:class="'domain-'+item.domain" v-if="item.domain === 'yahoo'">YAHOO!</span>
                    <span v-bind:class="'domain-'+item.domain" v-if="item.domain === 'amazon'">amazon</span>
                    <span v-bind:class="'domain-'+item.domain" v-if="item.domain === 'rakuten'">楽天</span>
                  </a>
                </span>
              </div>
            </li>
            </template>
          </ul>

          <div class="txt-center">
            <ul class="pagination">
              <li class="page-item pc-only" v-bind:class="{inactive : this.currentPage === 0}">
                <a @click="first" class="page-link">&laquo;</a>
              </li>
              <li class="page-item pc-only">
                <a @click="prev" class="page-link">&lt;</a>
              </li>

              <li
                v-for="i in displayPageRange"
                class="page-item"
                :class="{active: i-1 === currentPage}">
                <a @click="pageSelect(i)" class="page-link">{{ i }}</a>
              </li>

              <li class="page-item pc-only">
                <a @click="next" class="page-link">&gt;</a>
              </li>
              <li class="page-item pc-only" v-bind:class="{inactive : this.pages === this.currentPage + 1}">
                <a @click="last" class="page-link">&raquo;</a>
              </li>
            </ul>

            <ul class="sp-page-navi sp-only">
              <li class="sp-page-navi-prev" v-bind:class="{inactive : this.currentPage === 0}">
                <a @click="prev" class="page-link">前へ</a>
              </li>
              <li class="sp-page-navi-next" v-bind:class="{inactive : this.pages === this.currentPage + 1}">
                <a @click="next" class="page-link">次へ</a>
              </li>
            </ul>
          </div><!-- / .txt-center -->
        </div>
                  </div>
                </div>
</template>

<script>
import axios from 'axios'
//import EventHub from './EventHub'

export default {
  name: 'App',

  data () {
    return {
      ec       : this.$route.query.ec ? this.$route.query.ec : Cookies.get('ec') ? Cookies.get('ec')  : 'amazon,yahoo,rakuten',
      isMobile : 0,
      items    : [],
      category : this.$route.query.category ? this.$route.query.category : 'ALL',
      query    : this.$route.query.q ? this.$route.query.q               : '',
      keyword  : '',
      hits     : 30,
      offset  : 0,
      sort    : {
        key   :  this.$route.query.sort ? this.$route.query.sort : '',
        isAsc : true,
        label : '並び替え'
      },
      sortOptions : [
        {
          'label' : '標準',
          'value' : 'normal'
        },
        {
          'label' : '価格が低い順',
          'value' : 'price0'
        },
        {
          'label' : '価格が高い順',
          'value' : 'price1'
        }
      ],
      price: {
        min : this.$route.query.minPrice ? this.$route.query.minPrice : undefined,
        max : this.$route.query.maxPrice ? this.$route.query.maxPrice : undefined,
      },
      temp: {
        price: {
          min: '',
          max: ''
        },
        showOnlyAvailable : this.$route.query.availability ? this.$route.query.availability === 'true' : false,
      },
      isLoading    : true,
      isFilterShow : false,
      showOnlyAvailable : this.$route.query.availability ? this.$route.query.availability === 'true' : false,
      resultCount : 1,
      size        : 24,
      currentPage : this.$route.query.page ? this.$route.query.page : 0,
      isPageFirst : true,
      isPageLast  : false,
      pageRange   : 10,
      error       : {
        noResult   : '',
        priceError : ''
      },
      ad_conf : this.ad_conf,
      ad_html: ''
    }
  },
  beforeMount () {
    //  リロード対策
    //  ロード時のクエリーパラメーターを読み取って検索
  },
  mounted() {
    var mql = window.matchMedia('screen and (max-width: 750px)')
    var self = this
    function checkBreakPoint(mql) {
      if (mql.matches) {
        // スマホ向け
        self.pageRange = 8
      } else {
        self.pageRange = 10
      }
    }

    self.ad_conf = window.ad_conf;





    // ブレイクポイントの瞬間に発火
    mql.addListener(checkBreakPoint);

    // 初回チェック
    checkBreakPoint(mql);

    //指定ドメインをクッキーから取得
    //if(Cookies.get('ec')) {
    //  this.ec = Cookies.get('ec')
    //}

    //hiddenパラムに初期値をセット
    let $form = document.forms.searchForm
    $form.sort.value         = self.sort.key
    $form.availability.value = self.showOnlyAvailable
    $form.ec.value           = self.ec
    $form.minPrice.value     = self.price.min || ''
    $form.maxPrice.value     = self.price.max || ''

    let $formSP  = document.forms.searchFormSP
    $formSP.sort.value         = self.sort.key
    $formSP.availability.value = self.showOnlyAvailable
    $formSP.ec.value           = self.ec
    $formSP.minPrice.value     = self.price.min || ''
    $formSP.maxPrice.value     = self.price.max || ''

    this.loadAdHtml();
  },
  created: function () {

    let self = this

    if(self.query !== '' || self.category !== '') {
      if(self.category === 'ALL') {
        self.keyword    = self.query
        Cookies.set('head_category','ALL')
      } else {
        self.keyword    = self.category + ' ' + self.query
      }
      document.title   = self.keyword.length > 0 ? self.keyword + 'の検索結果 | TRIP MALL' : '検索キーワードが未設定です。 | TRIP MALL';
      const el         = document.querySelector('.breadcrumb li:last-child')
      el.innerHTML     = self.keyword.length > 0 ? self.keyword + 'の検索結果' : '検索キーワードが未設定です。'
      const searchForm = document.querySelectorAll('input[name="q"]')
      let selectedCat  = Cookies.get('head_category')

      searchForm.forEach(function(elem, index) {
        let formVal = self.keyword.replace(selectedCat, '')
        elem.value = formVal.trim() //カテゴリー連結時に付ける半角スペースを削除
      });
      this.search()
    } else {
        this.error.noKeyword = '検索キーワードは全角１文字、半角２文字以上入力してください'
    }
  },

  methods: {
    loadAdHtml: function() {
      fetch("/assets/js/ad.html").then((res) => {
        res.text().then((html) => {
          this.ad_html = html;
        });
      });
    },
    search: function () {
      this.isLoading =  true
      if(Array.isArray(this.ec)) {
        this.ec = this.ec[0]
      }
      //  ページネーション初期化
      this.currentPage = 0

      //エラー処理
      if(this.charcount(this.keyword) < 2 || this.keyword === '') {
        this.error.noKeyword = '検索キーワードは全角１文字、半角２文字以上入力してください'
        this.isLoading =  false
        return
      }
      //  APIリクエスト
      const yahooPage1 = axios.get('/search/api/yahoo-api.php', {
        params: {
          q      : this.keyword,
          hits   : 30,
          offset : 0,
          price_from : this.price.min,
          price_to : this.price.max,
        }
      })
      const yahooPage2 = axios.get('/search/api/yahoo-api.php', {
        params: {
          q      : this.keyword,
          hits   : 30,
          offset : 30,
          price_from : this.price.min,
          price_to : this.price.max,
        }
      })
      const yahooPage3 = axios.get('/search/api/yahoo-api.php', {
        params: {
          q      : this.keyword,
          hits   : 30,
          offset : 60,
          price_from : this.price.min,
          price_to : this.price.max,
        }
      })
      const rakutenPage1 = axios.get('/search/api/rakuten-api.php', {
        params: {
          q: this.keyword,
          hits: this.hits,
          page:1,
          minPrice : this.price.min,
          maxPrice : this.price.max,
        }
      })
      const rakutenPage2 = axios.get('/search/api/rakuten-api.php', {
        params: {
          q: this.keyword,
          hits: 30,
          page: 2,
          minPrice : this.price.min,
          maxPrice : this.price.max,
        }
      })
      const rakutenPage3 = axios.get('/search/api/rakuten-api.php', {
        params: {
          q: this.keyword,
          hits: 30,
          page: 3,
          minPrice : this.price.min,
          maxPrice : this.price.max,
        }
      })
      const amazonPage1 = axios.get('/search/api/amazon-api.php', {
        params: {
          q            : this.keyword,
          ItemPage     : 1,
          MinimumPrice : this.price.min,
          MaximumPrice : this.price.max,
          Condition    : 'New'         //  新品のみ
        }
      })
      const amazonPage2 = axios.get('/search/api/amazon-api.php', {
        params: {
          q            : this.keyword,
          ItemPage     : 2,
          MinimumPrice : this.price.min,
          MaximumPrice : this.price.max,
          Condition    : 'New'         //  新品のみ
        }
      })
      const amazonPage3 = axios.get('/search/api/amazon-api.php', {
        params: {
          q            : this.keyword,
          ItemPage     : 3,
          MinimumPrice : this.price.min,
          MaximumPrice : this.price.max,
          Condition    : 'New'         //  新品のみ
        }
      })

      let requestsArray = []
      if(this.ec.indexOf('yahoo') >= 0) {
        requestsArray.push(yahooPage1)
        requestsArray.push(yahooPage2)
        requestsArray.push(yahooPage3)
      }
      if(this.ec.indexOf('rakuten') >= 0) {
        requestsArray.push(rakutenPage1)
        requestsArray.push(rakutenPage2)
        requestsArray.push(rakutenPage3)
      }
      if(this.ec.indexOf('amazon') >= 0) {
        requestsArray.push(amazonPage1)
        requestsArray.push(amazonPage2)
        requestsArray.push(amazonPage3)
      }

      let self = this

      axios.all(requestsArray).then(function(results) {
        let temp = results.map(r => r.data);
        let result = []
        for(let i in temp) {
          if(temp[i] && temp[i].items) {
            temp[i].items.forEach(function(val, index) {
              if(val.price && val.itemImage) {
                if(self.price.min && self.price.min <= val.price) {
                    result.push(val);
                }
                if(self.price.max && self.price.max <= val.price) {
                    result.push(val);
                }
                if(!self.price.min || !self.price.max) {
                    result.push(val);
                }
              }
            });
          } else {
            console.warn(temp[i]);
          }
        }
        //標準の並びに並べ替え
        const orderArray = ['amazon','amazon','yahoo','yahoo','rakuten','rakuten']
        let groups = _.groupBy(result, function(val) {
          return val.domain
        })
        let diff         = _.difference(orderArray, self.ec.split(','))
        let unSelectedEC = _.uniq(diff)
        let normalOrder  = _.pullAll(orderArray, unSelectedEC )

        let shopIndex   = {
          'yahoo'   : 0,
          'rakuten' : 0,
          'amazon'  : 0,
        }
        let sortedResult = []
        let selectedEC   = self.ec.split(',')

        //ECが２つ以上ある時だけソート
        if(selectedEC.length >= 2) {
          for(let i = 0; i < Math.ceil(result.length / normalOrder.length); i ++) {
            for(let j = 0; j < normalOrder.length; j++) {
              let currentShop = normalOrder[j]
              let nextShop    = function() {
                for(let k in selectedEC) {
                  if(selectedEC[k] !== currentShop) {
                    return selectedEC[k]
                  }
                }
              }()
              let lastShop    = function() {
                for(let k in selectedEC) {
                  if(selectedEC[k] !== currentShop && selectedEC[k] !== nextShop) {
                    return selectedEC[k]
                  }
                }
              }()

              if(groups[currentShop] && groups[currentShop][shopIndex[currentShop]]) {
                sortedResult.push(groups[currentShop][shopIndex[currentShop]])
                shopIndex[currentShop]++
              } else if(nextShop && groups[nextShop] && groups[nextShop][shopIndex[nextShop]]) {
                sortedResult.push(groups[nextShop][shopIndex[nextShop]])
                shopIndex[nextShop]++
              } else if(lastShop && groups[lastShop] && groups[lastShop][shopIndex[lastShop]]) {
                sortedResult.push(groups[lastShop][shopIndex[lastShop]])
                shopIndex[lastShop]++
              }
            }
          }
          self.items = sortedResult
        } else {
          self.items = result
        }
        self.resultCount = self.items.length
        self.isLoading = false
      })
    },

    charcount: function (str) {
      let len = 0;
      str = escape(str)
      for (let i = 0; i < str.length; i++, len++) {
        if (str.charAt(i) === '%') {
          if (str.charAt(++i) === 'u') {
            i += 3
            len++
          }
          i++
        }
      }
      return len
    },
    /**
     * ページ先頭に移動する
     */
    first () {
      this.currentPage = 0;
      this.selectHandler()
    },
    /**
     * ページ後尾に移動する
     */
    last () {
      this.currentPage = this.pages - 1
      this.selectHandler()
    },
    /**
     * 1ページ前に移動する
     */
    prev () {
      if (this.currentPage > 0) {
        this.currentPage--
        this.selectHandler()
      }
    },
    /**
     * 1ページ次に移動する
     */
    next () {
      if (this.currentPage < this.pages - 1) {
        this.currentPage++
        this.selectHandler()
      }
    },
    /**
     * 指定したページに移動する
     * @param {number} index ページ番号
     */
    pageSelect (index) {
      this.currentPage = index - 1
      this.selectHandler()
    },
    /**
     * ページを変更したときの処理
     */
    selectHandler () {
      window.scrollTo(0,0);
      let opt = {
        page: this.currentPage + 1
      }
      this.$router.push({
        query: Object.assign({}, this.$route.query, opt)
      })
    },
    // sort用キーをセットし、昇順・降順を入れ替える
    sortBy: function (obj) {
      let orderKey   = obj.value.slice(0, -1)
      let order      = obj.value.slice(-1)
      this.sort.isAsc = order === '0' ? true : false
      this.sort.label = obj.label
      this.sort.key = obj.value
      return false;
    },
    sortedClass: function (key) {
      return this.sort.key === key ? `sorted ${this.sort.isAsc ? 'asc' : 'desc' }` : '';
    },

    resetPrice: function() {
      this.temp.price.min = ''
      this.temp.price.max = ''
      this.price.min = ''
      this.price.max = ''
    },
    //  価格範囲を設定
    setFilterCondition: function () {
      this.showOnlyAvailable = this.temp.showOnlyAvailable ? this.temp.showOnlyAvailable : null
      let minPrice = this.temp.price.min
      let maxPrice = this.temp.price.max
      let zenkakuNum = /[０-９]/g
      let num = /[0-9０-９]/g

      if(zenkakuNum.test(minPrice)) {
        minPrice = minPrice.replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 65248);
        });
      }
      if(zenkakuNum.test(maxPrice)) {
        maxPrice = maxPrice.replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 65248);
        });
      }
      if(num.test(minPrice) ) {
        minPrice = minPrice * 1
      }
      if(num.test(maxPrice) ) {
        maxPrice = maxPrice * 1
      }

      if(minPrice !== '' && maxPrice !== '' && minPrice > maxPrice ) {
        //console.log('price error')
        this.error.priceError = '最低価格が最高価格を上回っています。'
        return
      }

      if(minPrice !== '' || maxPrice !== '') {
        if(minPrice !== '' && !num.test(minPrice)) {
          //console.log('min type error', minPrice)
          this.error.priceError = '最低価格に数値以外の文字が入力されています。'
          return
        }
        if(maxPrice !== '' && !num.test(maxPrice)) {
          //console.log('max type error', maxPrice)
          this.error.priceError = '最高価格に数値以外の文字が入力されています。'
          return
        }
      }

      //console.log('問題なし')
      //console.log('------------------------------')

      this.error.priceError = ''
      this.price.min    = minPrice
      this.price.max    = maxPrice
      this.isFilterShow = false
    },
    resetSort: function() {
      this.sort.key   = 'normal'
      this.sort.label = '標準'
    },
    resetAvailable: function() {
      this.temp.showOnlyAvailable = false
      this.showOnlyAvailable      = false
    },
    resetFilterCondition: function() {
      this.price.min = ''
      this.temp.price.min = ''
      this.price.max = ''
      this.temp.price.max = ''
      this.temp.showOnlyAvailable = false
      this.showOnlyAvailable = false
      this.isFilterShow = false
      this.error.priceError = ''

    },
    toggleFilter: function() {
      this.isFilterShow = !this.isFilterShow
    },
    closeFilter: function() {
      this.isFilterShow = false
    },

    checkNumber: function() {
    },

    updateData: function(to,from) {
      let before = from.query
      let after  = to.query
      let diff = _.omitBy(after, (v, k) => before[k] === v)
      if(diff.hasOwnProperty('sort')) {
        this.sort.key = diff.sort
      }
      if(diff.hasOwnProperty('availability')) {
        this.showOnlyAvailable = diff.availability
      }
      if(diff.hasOwnProperty('minPrice')) {
        this.price.min = diff.minPrice
      }
      if(diff.hasOwnProperty('maxPrice')) {
        this.price.max = diff.maxPrice
      }
      if(diff.hasOwnProperty('page')) {
        this.currentPage = diff.page - 1
      } else {
        this.currentPage = 0
      }
    },

  },
  computed: {
    /**
     * ソートキー
     */
    /**
     * ページ数を取得する
     * @return {number} 総ページ数(1はじまり)
     */
    pages () {
      if(this.sortedItems) {
        return Math.ceil(this.sortedItems.length / this.size)
      } else {
        return Math.ceil(this.items.length / this.size)
      }
    },
    /**
     * ページネーションで表示するページ番号の範囲を取得する
     * @return {Array<number>} ページ番号の配列
     */
    displayPageRange () {
      const half = Math.ceil(this.pageRange / 2)
      let start, end;

      if (this.pages < this.pageRange) {
        // ページネーションのrangeよりページ数がすくない場合
        start = 1;
        end = this.pages;

      } else if (this.currentPage < half) {
        // 左端のページ番号が1になったとき
        start = 1;
        end = start + this.pageRange - 1;

      } else if (this.pages - half < this.currentPage) {
        // 右端のページ番号が総ページ数になったとき
        end = this.pages;
        start = end - this.pageRange + 1;

      } else {
        // activeページを中央にする
        start = this.currentPage - half + 1;
        end = this.currentPage + half;
      }

      let indexes = [];
      for (let i = start; i <= end; i++) {
        indexes.push(i)
      }
      return indexes
    },
    /**
     * 現在のページで表示するアイテムリストを取得する
     * @return {any} 表示用アイテムリスト
     */
    displayItems () {
      const head = this.currentPage * this.size;


      return this.sortedItems.slice(head, head + this.size)
    },
    /**
     * 現在のページかどうか判定する
     * @param {number} page ページ番号
     * @return　{boolean} 現在のページならtrue
     */
    isSelected (page) {
      return page - 1 === this.currentPage;
    },

    //ソート
    sortedItems () {
      let list    = this.items.slice()  // ソート時でdataの順序を書き換えないため
      let sortKey = '';
      if(this.sort.key === 'normal') {
        sortKey = this.sort.key
      } else {
        sortKey   = this.sort.key.slice(0,-1)
      }
      let sortOrder = this.sort.key.slice(-1)  // ASC or DSC
      this.sort.isAsc = sortOrder === '0' ? true : false

      if (!!sortKey && sortKey === 'price' || sortKey === 'reviewRate') {
        list.sort((a, b) => {
            a = a[sortKey]
            b = b[sortKey]
            a = Number(a);
            b = Number(b);
          return (a === b ? 0 : a > b ? 1 : -1) * (this.sort.isAsc ? 1 : -1)
        });
      }
      let result;
      if(this.showOnlyAvailable === true) {
        var availableList = _.filter(list, { 'availability': 1 })
        result =  availableList
      } else {
        result = list
      }
      return result
    }
  },
  watch: {
    '$route' (to, from) {
      this.updateData(to,from)
    },
    ec : function() {
      var $form        = document.forms.searchForm
      var $formSP      = document.forms.searchFormSP
      $form.ec.value   = this.ec
      $formSP.ec.value = this.ec
      let opt = {
        ec: this.ec
      }
      this.$router.push({
        query: Object.assign({}, this.$route.query, opt)
      })
      this.search()
    },
    showOnlyAvailable : function() {
      var $form   = document.forms.searchForm
      var $formSP = document.forms.searchFormSP
      $form.availability.value   = this.showOnlyAvailable
      $formSP.availability.value = this.showOnlyAvailable
      let opt = {
        availability: this.showOnlyAvailable
      }
      this.$router.push({
        query: Object.assign({}, this.$route.query, opt)
      })
    },
    price : {
      handler(val) {
        var $form = document.forms.searchForm
        var $formSP = document.forms.searchFormSP
        $form.minPrice.value   = this.price.min
        $formSP.minPrice.value = this.price.min
        $form.maxPrice.value   = this.price.max
        $formSP.maxPrice.value = this.price.max
        let opt = {
          minPrice: this.price.min,
          maxPrice: this.price.max
        }
        this.$router.push({
          query: Object.assign({}, this.$route.query, opt)
        })
        this.search()
      },
      deep: true
    },
    sort : {
      handler(val) {
        var $form = document.forms.searchForm
        var $formSP = document.forms.searchFormSP
        $form.sort.value = this.sort.key
        $formSP.sort.value = this.sort.key
        let opt = {
          sort: this.sort.key
        }
        this.$router.push({
          query: Object.assign({}, this.$route.query, opt)
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue